export default {
  pt: {
    title:
      'Políssonos - um sequenciador Midi baseado em polígonos - Digitópia, Casa da Música - Porto',
    timeline:
      'Clique e arraste para seleccionar o ponto de partida do sequenciador.',
    'grid-item':
      'Clique num quadrado do sequenciador para lhe atribuir o polígono seleccionado na respectiva pista. Clique com o botão do lado,direito para remover a selecção.',
    'play-grid':
      'Clique para iniciar o sequenciador no ponto seleccionado. Clique novamente para parar.',
    bpms: 'Clique e arraste para definir o número de pulsações (batidas) por minuto.',
    open: 'Clique para abrir um ficheiro ".psn" (Políssonos).',
    save: 'Clique para gravar a sessão como ficheiro ".psn" (Políssonos) ou ".mid" (Midi).',
    'lang-pt': 'Clique para alterar a linguagem para Português.',
    'lang-en': 'Click to change the language to English.',
    scene:
      'Clique num dos quadrados para seleccionar um novo polígono. Clique e arraste para copiar o polígono para uma nova posição.',
    note: 'Clique num dos vértices para o seleccionar e activar (arraste na vertical para definir a nota da escala de imediato). Clique com,o botão do lado direito para o desactivar.',
    'note-chooser':
      'Clique e arraste para definir a nota da escala a ser tocada no vértice seleccionado.',
    volume:
      'Clique e arraste para definir o volume da nota a ser tocada no vértice seleccionado. Escolha o volume 0 para obter uma pausa.',
    play: 'Clique para tocar esta pista. Clique novamente para parar.',
    settings: 'Clique para aceder ao menú de configuração desta pista.',
    'settings-instrument':
      'Clique nas setas para escolher o instrumento da pista seleccionada.',
    'settings-root':
      'Clique nas setas para escolher a transposição do modo seleccionado.',
    'settings-scale':
      'Clique nas setas para escolher o modo da pista seleccionada.',
    'settings-beats':
      'Clique nas setas para escolher o número de pulsações (batidas) contidos nos polígonos da pista seleccionada.',
    'settings-subdivisions':
      'Clique nas setas para escolher a subdivisão de cada pulsação (batida) da pista seleccionada.',
    sphere: 'Seleccione uma das pistas para obter uma visualizção 3D da mesma.',
    'sphere.active': 'Visualização 3D da pista seleccionada.',
    scale: {
      pentatonic: 'pentatónico',
      dorian: 'dórico',
      mixolydian: 'mixolídio',
      major: 'modo maior',
      octatonic: 'octatónico',
    },
    root: {
      'C#': 'Dó# / Réb',
      'G#': 'Sol# / Láb',
      'D#': 'Ré# / Mib',
      'A#': 'Lá# / Sib',
      F: 'Fá',
      C: 'Dó',
      G: 'Sol',
      D: 'Ré',
      A: 'Lá',
      E: 'Mi',
      B: 'Si',
      'F#': 'Fá# / Solb',
    },
  },
  en: {
    title:
      'Políssonos - a Midi sequencer based on polygons - Digitópia, Casa da Música - Porto, Portugal',
    timeline: 'Click and drag to set the starting offset of the sequencer.',
    'grid-item':
      'Click on a sequencer square to set it to the selected polygon of each track. Click with the right button to remove the selection.',
    'play-grid':
      'Click to start the sequencer on the selected offset. Click again to stop it.',
    bpms: 'Click and drag to set the number of beats per minute.',
    open: 'Click to open a ".psn" (Políssonos) file.',
    save: 'Click to save the session as a ".psn" (Políssonos) or a ".mid" (Midi) file.',
    'lang-pt': 'Clique para alterar a linguagem para Português.',
    'lang-en': 'Click to change the language to English.',
    scene:
      "Click on one of the squares to change to it's polygon. Click and drag to copy it to a new location.",
    note: 'Click on one of the vertices to select and activate it (drag vertically to select the note immediately). Click with the right button to de-activate it again.',
    'note-chooser':
      'Click and drag to select the note that shall be played on the selected vertices.',
    volume:
      'Click and drag to select the volume of the note that shall be played on the selected vertices. Select a volume of 0 to make a rest.',
    play: 'Click to start playing this track. Click again to stop it.',
    settings: 'Click to access the configuration menu of this track.',
    'settings-instrument':
      'Click on the arrows to select the instrument of the selected track.',
    'settings-root':
      'Click on the arrows to select the transposition of the selected mode.',
    'settings-scale':
      'Click on the arrows to select the mode of the selected track.',
    'settings-beats':
      'Click on the arrows to select the number of beats each of the polygons of the selected track will have.',
    'settings-subdivisions':
      'Click on the arrows to select the a subdivision of the beat of the selected track.',
    sphere: 'Select one of the tracks to see its 3D view.',
    'sphere.active': '3D view of the selected track.',
    scale: {
      pentatonic: 'pentatonic',
      dorian: 'dorian',
      mixolydian: 'mixolydian',
      major: 'major',
      octatonic: 'octatonic',
    },
    root: {
      'C#': 'C# / Db',
      'G#': 'G# / Ab',
      'D#': 'D# / Eb',
      'A#': 'A# / Bb',
      F: 'F',
      C: 'C',
      G: 'G',
      D: 'D',
      A: 'A',
      E: 'E',
      B: 'B',
      'F#': 'F# / Gb',
    },
  },
}
